var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOverlayBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Menu with BG",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1366,
    height: 768,
    viewBox: "0 0 1366 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d9fpprt8ha",
    x1: 1,
    y1: 0.5,
    x2: -0.032,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "BG Shadows",
    style: {
      opacity: 0.656
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d9fpprt8ha)"
    },
    d: "M0 0h683v1366H0z",
    transform: "rotate(90 683 683)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d9fpprt8ha)"
    },
    d: "M0 0h454v682H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d9fpprt8ha)"
    },
    d: "M0 0h682v1366H0z",
    transform: "rotate(90 683 683)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "BG Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d9fpprt8ha)"
    },
    d: "M0 0h683v768H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d9fpprt8ha)"
    },
    d: "M0 0h453v1366H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "transparent"
    },
    d: "M0 0h1366v768H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d9fpprt8ha)"
    },
    d: "M0 0h683v768H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOverlayBg);
export default __webpack_public_path__ + "static/media/menu-overlay-bg.61c0da1fc7e83e6444ad3d276f10d40c.svg";
export { ForwardRef as ReactComponent };